<template>
  <div 
    :class="baseStackItemClasses" 
    class="base-stack-item" 
    v-on="$listeners"
  >
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  fill: {
    type: Boolean,
    default: false,
  },
});

const baseStackItemClasses = computed(() => ({
  "base-stack-item--fill": props.fill,
}));
</script>

<style lang="scss" scoped>
@import "./base-stack-item.scss";
</style>
